import base from "../baseurl";
import token from "../getTk";

const Create = async (name) => {
  console.log("Crear", name);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const create = await api
    .post("industrial-parks/create", {
      timeout: false,
      json: {
        name,
      },
    })
    .json();
  console.log("Crear", create);
  return create;
};

export default Create;
